export default __webpack_public_path__ + "static/media/PulseRate.6b3edbd2.svg";